import React, { useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { documentsActions, fileActions } from '../../store/actions'
import { useNavigate, useLocation } from 'react-router-dom'

//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from '../cargarDocs/CargarDocsStyles'

import { cargarDocsFunctions } from '../cargarDocs/CargarDocsFunctions'
import { CustomCounterAppBar, InputField, CustomLoadingOverlay ,Buttons } from '../../components'

import {
    Typography,
    useMediaQuery,useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function FormWebCamera(props) {
    const matches = useMediaQuery('(min-width:650px)');
    const gridContainer = {} //mainStyles.gridStyle()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()

    const [loadView, setLoadView] = useState(false)
    const [metaToSend, setMetaToSend] = useState(false)
    const [activeOrder, setActiveOrder] = useState(false)
    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [metadatos, setMetadatos] = useState([])
    const [fields, setFields] = useState([])
    const [formData, setFormData] = useState([]);

    const folioId = location.state.folioId
    const sectionId = location.state.sectionId
    const docName = location.state.docName
    const qrProcess = location.state.qrProcess
    const document = location.state.doc
    const actorId = location.state.actorId

    const file = useSelector(state => state.FileInfo)
    const uploadSecDoc = useSelector(state => state.UploadSections)
    const registeredData = useSelector(state => state.MetadaData)
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const dataToSend = {
        B64Content: document,
        FileId: folioId,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: sectionId,
        Extension: '.jpg',
        Skip: false,
        SkipReason: null,
        Metadata: metadatos.length > 0 ? metadatos : null, //pending
        ContinueWorkFlow: false, //to upload all files before moving
        Geolocation: null, //Pending
        DeferLoad: false // heavy file, true to load on backgroud 
    }


    const sendDocAction = () => {
        setLoadView(true)
        console.log("Datos envio Back: ", dataToSend)
        dispatch(documentsActions.CargaSeccion(dataToSend))
    }

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        // console.log("-------location.state.metadatos---------------------: ", location.state.metadatos)
        setMetadatos(location.state.metadatos)
        setFields(cargarDocsFunctions.getNewFieldName(docName))
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined) {
            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)
        }
    }, [file])

    useEffect(() => {
        if (metadatos.length > 0 && !metaToSend) {
            console.log("Metadatos recibidos: ", metadatos)
            let newData = metadatos.map((data) => {
                // console.log("Metadatos recibidos data-----------------: ",data)
                let findValues = fields.find(field => data.Name === field.OnlineFieldName || data.Campo === field.OnlineFieldNameOCR)
                // console.log("fields fields-------------: ",fields)
                // console.log("fields fields-------------: ",fields)
                return {
                    GroupName: data.GroupName === undefined ? "" : data.GroupName,
                    Value: data.Value === undefined ? "" : data.Value,
                    Name: data?.Campo === undefined ? findValues.OnlineFieldNameOCR : findValues?.FieldQuestionName,
                    Label: findValues?.FieldName,
                    Sequence: findValues?.Sequence
                }
            })
            let orderArray = newData.sort((a, b) => a.Sequence - b.Sequence)
            setFormData(orderArray)
        } else if (metadatos.length > 0 && loadView && metaToSend) {
            setFormData([])
            sendDocAction()
        }
    }, [metadatos])

    useEffect(() => {
        if (uploadSecDoc.items != undefined && uploadSecDoc.items?.Result != undefined && loadView) {
            if ((uploadSecDoc.items.Result?.Id != null || uploadSecDoc.items.Result?.Id != undefined && metaToSend)) {
                dispatch(documentsActions.RegisterMetadata({
                    Document_Id: uploadSecDoc.items.Result.Id,
                    Metadata: metadatos
                }))
            }
        }
        if (uploadSecDoc.error != undefined && loadView && metaToSend) {
            setLoadView(false)
            alert(uploadSecDoc.error)
        }
    }, [uploadSecDoc])

    useEffect(() => {
        if (registeredData.items && loadView && metaToSend) {
            const nextComponent = 'CargarDocsComponent'
            cargarDocsFunctions.nextIndocLoading({ navigate, folioId, nextComponent, qrProcess })
        }
        if (registeredData.error != undefined && loadView && metaToSend) {
            alert(registeredData.error)
            setLoadView(false)
        }
    }, [registeredData])

    const setNewMetadata = () => {
        setLoadView(true)
        // console.log("formData---sende values: ",formData)
        const newMeta = formData.map((fields) => {
            return {
                GroupName: fields.GroupName,
                Value: fields.Value,
                Name: fields.Name
            }
        })

        setMetaToSend(true)
        setMetadatos(newMeta)
    }

    return (
        <div className={gridContainer.container}>
            <div className={gridContainer.leftColumn}></div>
            {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
            <div className={gridContainer.centerColumn}>
                <CustomCounterAppBar
                    initialStep={currentStage}
                    endingStep={totalStage}
                    viewMenu={qrProcess ? false : true} />
                {formData.length > 0
                    && <div className={localStyles.modal}>
                        <div className={localStyles.helpModalTextForm}>
                            <Typography variant="body1" gutterBottom>
                              {t("cargar_data_capture")}
                            </Typography>
                            <Typography variant="subtitle1" className={localStyles.p}>
                              {t("capture_verification")}
                            </Typography>
                        </div>
                        <div className={localStyles.form}>
                            {formData.map((input, index) => {
                                return <div className={localStyles.inputField}>
                                    <InputField
                                        type='Text'
                                        variant='outlined'
                                        label={input.Label}
                                        name={input.Name}
                                        value={input.Value}
                                        onChange={(e) => {
                                            let newArr = [...formData]
                                            newArr[index].Value = e.target.value
                                            setFormData(newArr)
                                            console.log('formChanges', formData)
                                            // Edit value of an Object inside an Array 
                                        }}
                                    />
                                </div>
                            })}
                        </div>
                        <Buttons
                            background_color={theme.palette.primary.main}
                            text_color='#FFFFFF'
                            border_color={theme.palette.primary.main}
                            text={t("general_accept")}
                            type='button'
                            className={localStyles.cargarMetaBtn}
                            click={setNewMetadata}
                        />
                    </div>}
            </div>
            <div className={gridContainer.rightColumn}></div>
        </div>
    )
}

